import { render, staticRenderFns } from "./LabelPromo.vue?vue&type=template&id=269818fa&scoped=true&"
import script from "./LabelPromo.vue?vue&type=script&lang=js&"
export * from "./LabelPromo.vue?vue&type=script&lang=js&"
import style0 from "./LabelPromo.vue?vue&type=style&index=0&id=269818fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269818fa",
  null
  
)

export default component.exports